// src/components/Events/Tree/DraggableDecoration.jsx
import React from "react";
import { Box } from "@mui/material";
import { useDraggable } from "@dnd-kit/core";

export default function DraggableDecoration({ id, disabled, children }) {
    const { attributes, listeners, setNodeRef, transform, isDragging } =
        useDraggable({ id, disabled });

    return (
        <Box
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            sx={{
                transform: transform
                    ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                    : "none",
                touchAction: "none",
                willChange: "transform",
                zIndex: isDragging ? 9999 : "auto",
            }}
        >
            {children}
        </Box>
    );
}
